import { render, staticRenderFns } from "./ProcessosClientesStats.vue?vue&type=template&id=24af363e&"
import script from "./ProcessosClientesStats.vue?vue&type=script&lang=js&"
export * from "./ProcessosClientesStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports